import { pdfPhoneParam } from "../utils/pdfBootParams"
import { PhoneContext } from "./PhoneContext"
import React, { useEffect, useRef, useState } from "react"

export const PhoneProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // generator-only param: seeds the owner's number for the phone editions
    // (?pdf=1&phone=66912341234); never present on shipped URLs
    const fromPdf = pdfPhoneParam()

    const [code, setCode] = useState<string>(() => {
        if (fromPdf) return fromPdf.code
        if (typeof window !== "undefined") {
            return localStorage.getItem("phoneCode") ?? ""
        }
        return ""
    })

    const [rest, setRest] = useState<string>(() => {
        if (fromPdf) return fromPdf.rest
        if (typeof window !== "undefined") {
            return localStorage.getItem("phoneRest") ?? ""
        }
        return ""
    })

    const [show, setShow] = useState<boolean>(() => {
        if (fromPdf) return true
        if (typeof window !== "undefined") {
            return localStorage.getItem("showPhone") === "true"
        }
        return false
    })

    // debounced — a keystroke writes at most once per 300ms
    const timers = useRef<Record<string, ReturnType<typeof setTimeout>>>({})
    const persist = (key: string, value: string) => {
        clearTimeout(timers.current[key])
        timers.current[key] = setTimeout(() => localStorage.setItem(key, value), 300)
    }
    useEffect(() => () => Object.values(timers.current).forEach(clearTimeout), [])

    const value = {
        code,
        rest,
        show,
        setCode: (v: string) => {
            setCode(v)
            persist("phoneCode", v)
        },
        setRest: (v: string) => {
            setRest(v)
            persist("phoneRest", v)
        },
        setShow: (v: boolean) => {
            setShow(v)
            persist("showPhone", String(v))
        },
    }

    return <PhoneContext.Provider value={value}>{children}</PhoneContext.Provider>
}
